import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/clientes',documento:'catalogs',acceso:'sesion',filas:['072'],cita:'Areas/Catalogs/Controllers/CustomersController.cs:51'} satisfies RutaProd;
